import { useState } from 'react';


const ThemeNine = ({ attributes, setAttributes }) => {

    const { faqData = [], faqIcon = {} } = attributes || {};
    const { open, close } = faqIcon;
    const [activeIndex, setActiveIndex] = useState(0);

    const handleClick = (i) => {
        setActiveIndex(i);
        setAttributes({ activeItem: i });
    }

    return (
        <div className="ThemeNineWrapper faq-container-style">
            <div className="faq-container">
                {faqData.map((faq, i) => (
                    <div
                        key={i}
                        className={`faq-item ${activeIndex === i ? "active" : ""}`}
                        onClick={() => handleClick(i)}
                    >
                        <div className="faq-question">
                            <div className="faq-icon">
                                {activeIndex === i ? <span
                                    className="icon"
                                    dangerouslySetInnerHTML={{ __html: open }}
                                /> : <span
                                    className="icon"
                                    dangerouslySetInnerHTML={{ __html: close }}
                                />}
                            </div>

                            <div className="faq-question-title">
                                {faq?.question}
                            </div>
                        </div>

                        <div className="faq-answer">
                            <p className="faq-answer-para">{faq?.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ThemeNine;
